import { useTheme } from '@mui/material';

type Props = {
  isRead: boolean;
  isOldUi: boolean;
  isHovered: boolean;
  hasBorder: boolean;
};

export const useSxStyles = (props: Props) => {
  const theme = useTheme();
  const { isRead, isOldUi, isHovered, hasBorder } = props;

  return {
    listItem: {
      paddingTop: 0,
      paddingLeft: 0,
      paddingBottom: 0,
      ...(isOldUi && {
        padding: theme.spacing(0.5),
        '&:hover': {
          backgroundColor: isRead ? 'inherit' : '#e7f9ff',
        },
      }),
      ...(!isRead && { backgroundColor: '#e7f9ff' }),
      ...(hasBorder && { borderBottom: 'solid 1px #ddd' }),
      '> .MuiListItemButton-root': {
        paddingRight: 0,
      },
      ...(!isHovered && { paddingRight: theme.spacing(2) }),
    },
    listItemButton: {
      ...(isOldUi && { paddingLeft: theme.spacing(0.5) }),
    },
    listItemAvatar: {
      ...(isOldUi && { minWidth: 'auto' }),
    },
    avatar: {
      ...(isOldUi && {
        borderRadius: '2px',
        width: '36px',
        height: '36px',
        boxShadow: '0 3px 6px rgb(0 0 0 / 18%)',
        marginRight: '6px',
      }),
    },
    listItemText: {
      margin: 0,
    },
    primaryContent: {
      display: 'flex',
    },
    notificationContent: {
      color: theme.palette.text.primary,
    },
    secondaryContent: {
      fontSize: '0.75rem',
    },

    icon: { color: ' #025874', cursor: 'pointer' },
    iconSpacing: { marginRight: theme.spacing(0.5) },
    iconButton: { p: theme.spacing(0.25), fontSize: '1rem' },
    redIcon: {
      marginLeft: theme.spacing(),
      color: '#DC143C',
    },
    creditCardIcon: {
      marginLeft: theme.spacing(),
      color: theme.palette.text.secondary,
    },
    clockIcon: {
      marginRight: '5px',
      padding: '3px',
      color: '#05A4D8',
    },
    areaIcon: {
      marginLeft: '10px',
      color: '#05A4D8',
    },
  };
};
